import css from "./Intro.module.css";

const Intro = (props) => {
  const { children, primary, secondary, tertiary } = props;

  return (
    <div className={css.main}>
      <div className={css.content}>
        <h1>{primary}</h1>
        {secondary && <p className="ctext">{secondary}</p>}
        {tertiary && <p className={css.tertiary}>{tertiary}</p>}
        {children && children}
      </div>
    </div>
  );
};

export default Intro;
